var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1239_19996",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1239_19996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 14.6667C6.45588 14.2778 5.18088 13.3917 4.17533 12.0083C3.16977 10.625 2.66699 9.0889 2.66699 7.40001V3.33334L8.00033 1.33334L13.3337 3.33334V7.40001C13.3337 9.0889 12.8309 10.625 11.8253 12.0083C10.8198 13.3917 9.54477 14.2778 8.00033 14.6667ZM8.00033 13.2667C9.15588 12.9 10.1114 12.1667 10.867 11.0667C11.6225 9.96668 12.0003 8.74446 12.0003 7.40001V4.25001L8.00033 2.75001L4.00033 4.25001V7.40001C4.00033 8.74446 4.3781 9.96668 5.13366 11.0667C5.88921 12.1667 6.84477 12.9 8.00033 13.2667Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.92fea7b4a92d52f056fa1fd598770241.svg";
export { ForwardRef as ReactComponent };